import {



    GET_NOTIFICATIONS_REQUEST,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAIL,


    MARK_NOTIFICATIONS_REQUEST,
    MARK_NOTIFICATIONS_SUCCESS,
    MARK_NOTIFICATIONS_RESET,
    MARK_NOTIFICATIONS_FAIL,

    
  MARK_ALL_AS_READ_REQUEST,
  MARK_ALL_AS_READ_SUCCESS,
  MARK_ALL_AS_READ_RESET,
  MARK_ALL_AS_READ_FAIL,

  DELETE_ALL_NOTIFCATIONS_REQUEST,
  DELETE_ALL_NOTIFCATIONS_SUCCESS,
  DELETE_ALL_NOTIFCATIONS_RESET,
  DELETE_ALL_NOTIFCATIONS_FAIL,
    CLEAR_ERRORS



} from "../constants/notificationsConstants";

export const allNotificationsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true
            };

        case GET_NOTIFICATIONS_SUCCESS:
            return {
                loading: false,
                success: true,
                unread_count: action.payload.unread_count,
                notifications: action.payload.notifications,
                count: action.payload.count,
                totalPages: action.payload.totalPages,
                urgent_count: action.payload.urgent_count,
            };

        case GET_NOTIFICATIONS_FAIL:
            return {
                loading: false,
                error: action.payload,
                unread_count: null,
                notifications: null,
                count: null,
                totalPages: null,
                urgent_count: null,
            };


        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};
export const marknotificationsReducer = (state = {}, action) => {
    switch (action.type) {
        case MARK_NOTIFICATIONS_REQUEST:
        case MARK_ALL_AS_READ_REQUEST:
        case DELETE_ALL_NOTIFCATIONS_REQUEST:
            return {
                ...state,
                loading: true
            };

        case MARK_NOTIFICATIONS_SUCCESS:
        case MARK_ALL_AS_READ_SUCCESS:
        case DELETE_ALL_NOTIFCATIONS_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload.message,
            };

        case MARK_NOTIFICATIONS_FAIL:
        case MARK_ALL_AS_READ_RESET:
        case DELETE_ALL_NOTIFCATIONS_RESET:
            return {
                loading: false,
                error: action.payload,
            };
        case MARK_NOTIFICATIONS_RESET:
        case MARK_ALL_AS_READ_FAIL:
        case DELETE_ALL_NOTIFCATIONS_FAIL:
            return {
                loading: false,
                message: null,
            };


        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};
